import { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

export const TUTOR_KANBAN_EXIT_STAGES: TutorKanbanStage[] = [
  TutorKanbanStage.ExitDecisionRequest,
  TutorKanbanStage.ExitInProgress,
  TutorKanbanStage.ExitFinished,
]

export const TUTOR_KANBAN_REQUIRED_CATEGORY_STAGES: TutorKanbanStage[] = [
  TutorKanbanStage.ProbationFailed,
  TutorKanbanStage.ExitDecisionRequest,
  TutorKanbanStage.ExitInProgress,
  TutorKanbanStage.ExitFinished,
]

export const isTutorKanbanExitStage = (stage: TutorKanbanStage | null): boolean => {
  return !!stage && TUTOR_KANBAN_EXIT_STAGES.includes(stage)
}

export const isTutorKanbanRequiredCategoryStage = (stage: TutorKanbanStage | null): boolean => {
  return !!stage && TUTOR_KANBAN_REQUIRED_CATEGORY_STAGES.includes(stage)
}
